import { createEntityAdapter } from '@reduxjs/toolkit';

import { PropertyDataState } from '../types.ts';

export const propertyDataAdapter = createEntityAdapter<PropertyDataState>({});
